export const trackEvent = (name, payload = {}) => {
  if (window.location.hostname === 'localhost') return;
  // eslint-disable-next-line no-console
  console.log('[track]', name, payload);
};
